import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const MoveItemModal = ({ open, onClose, onSubmit, item, tables = [] }) => {
  const [quantity, setQuantity] = useState(item?.quantity || 1);
  const [targetTable, setTargetTable] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md")); // full screen on small tablets/phones

  // sync when item changes
  useEffect(() => {
    setQuantity(item?.quantity ?? 1);
    setTargetTable("");
  }, [item]);

  const handleSubmit = () => {
    if (!targetTable) return alert("يرجى اختيار طاولة مستهدفة");
    onSubmit({
      item_id: Number(item.id), // ✅ لازم رقم
      source_order_id: Number(item.order_id),
      quantity: Number(quantity),
      target_table: Number(targetTable),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 2, m: fullScreen ? 0 : 2 } }}
    >
      <DialogTitle>نقل الصنف: {item?.product_name}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="الكمية"
              type="number"
              value={quantity}
              onChange={(e) => {
                const val = Number(e.target.value) || 1;
                setQuantity(val);
              }}
              fullWidth
              size="medium"
              inputProps={{ min: 1, inputMode: "numeric", pattern: "[0-9]*" }}
              sx={{ "& .MuiInputBase-input": { fontSize: { xs: 16, md: 18 }, padding: "10px" } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>اختر الطاولة</InputLabel>
              <Select
                value={targetTable}
                label="اختر الطاولة"
                onChange={(e) => setTargetTable(Number(e.target.value))}
                size="medium"
                sx={{ "& .MuiSelect-select": { fontSize: { xs: 16, md: 18 }, padding: "10px" } }}
              >
                <MenuItem value="">
                  <em>-- اختر --</em>
                </MenuItem>
                {tables.map((table) => (
                  <MenuItem key={table.id} value={table.id}>
                    {`طاولة ${table.name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: fullScreen ? 2 : 1 }}>
        <Button onClick={onClose} fullWidth={fullScreen}>
          إلغاء
        </Button>
        <Button onClick={handleSubmit} variant="contained" fullWidth={fullScreen}>
          نقل
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveItemModal;
